<template>
  <v-list density="compact" nav class="px-4">
    <c360-aside-menu-expander :is-active="!isOpened" @click="onExpanderClick" />
    <div v-for="item in items" :key="item.id">
      <template v-if="item.subItems">
        <c360-navigation-drawer-expansion-panel
          :item="item"
          :is-opened="item.id == panel && isOpened"
          :is-panel-opened="isOpened"
          :active-element="activeElement"
          :open-only-by-expander="openOnlyByExpander"
          @panel-click="onPanelClick(item.id)"
          @select="$emit('select', $event)"
        />
      </template>

      <template v-else>
        <c360-navigation-drawer-item
          :key="item.id"
          :item="item"
          :is-active="item.id == activeElement"
          :is-panel-opened="isOpened"
          @click="$emit('select', item)"
        />
      </template>
    </div>
  </v-list>
</template>

<script>
  import Vue from 'vue';

  import { C360NavigationDrawerItem } from '../../../components/NavigationDrawerItem';
  import { C360NavigationDrawerExpansionPanel } from '../../../components/NavigationDrawerExpansionPanel';
  import { C360AsideMenuExpander } from '../../../components/AsideMenuExpander';

  export default Vue.extend({
    name: 'C360AsideMenu',

    components: {
      C360AsideMenuExpander,
      C360NavigationDrawerItem,
      C360NavigationDrawerExpansionPanel,
    },

    props: {
      /**
       * Grouped menu items.
       * @type {Array<{ title: string; icon?: string; disabled: boolean; subItems?: [{title: string;}] }>}
       */
      items: {
        type: Array,
        default: () => [],
      },

      /**
       * Active element id.
       */
      activeElement: {
        type: String,
        default: '',
      },

      /**
       * Is menu opened.
       */
      isOpened: {
        type: Boolean,
        default: false,
      },

      /**
       * Should menu be opened only by expander.
       */
      openOnlyByExpander: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      panel: '',
    }),

    methods: {
      onPanelClick(id) {
        this.panel = id;
        this.$emit('panel-click', id);
      },
      onExpanderClick() {
        this.$emit(this.isOpened ? 'hide' : 'expand');
      },
    },
  });
</script>

<style>
  .c360-navigation-drawer.v-navigation-drawer {
    background-color: #f5f5f5;
    min-width: 72px;
  }

  .c360-navigation-drawer-expand-menu-item:before {
    background: none;
  }

  .c360-navigation-drawer-expand-menu-item .v-ripple__container .v-ripple__animation {
    background-color: var(--c360-color-compulse) !important;
  }
</style>
